import { useMemo } from "react";

import type { IFiltersConfigCategoryItem } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/category";
import type { CategoryFiltersConfig } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filtersConfig";
import type { OrderedSearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";
import useLeadsDescriptionQuery from "app/pages/sales-intelligence/modules/leads-search-filters/queries/useLeadsDescriptionQuery";
import { siCountryService } from "app/pages/sales-intelligence/services/siCountryService";
import { useGetAllContactProfilesQuery } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/queries/useGetAllContactProfilesQuery";

import { createContactsFilterConfig } from "../configs/createContactsFilterConfig";
import { contactsCategories } from "../configs/filterCategory";

const CONTACTS_CATEGORIES: readonly IFiltersConfigCategoryItem[] = Object.values(contactsCategories);

export const useComputeContactsFiltersConfig = (): CategoryFiltersConfig<OrderedSearchFilterInstance> => {
    const { data: description } = useLeadsDescriptionQuery();
    const { data: profilesResponse } = useGetAllContactProfilesQuery();

    const { filtersList, status } = useMemo(
        () =>
            createContactsFilterConfig({
                filtersDescription: description,
                profilesResponse,
                filtersCountryService: siCountryService,
            }),
        [description, profilesResponse],
    );

    return { filtersList, status, categoriesList: CONTACTS_CATEGORIES };
};
